import {
  PLUGIN_KIND_REGISTRY,
  UNKNOWN_KIND,
  type MappingServiceViewModel,
  type VectorIndexProfile,
} from "@models/service";

export const buildMappingServiceViewModel = (
  profile: VectorIndexProfile,
): MappingServiceViewModel => {
  const kind = PLUGIN_KIND_REGISTRY[profile.plugin_id] ?? UNKNOWN_KIND;
  return {
    id: `${kind}#${profile.plugin_id}`,
    kind,
    pluginId: profile.plugin_id,
    modelName: profile.model_name,
    isDefault: profile.is_default,
    indexKinds: profile.index_kinds,
    dimension: profile.dimension,
    distanceMetric: profile.distance_metric,
  };
};

/**
 * De-duplicate the `/plugins` rows down to one row per `(kind, plugin)`
 * pair. The endpoint returns one row per `(plugin, model)` pair — the
 * dashboard surfaces services not embedding models, so collapse and
 * prefer the `is_default` row when present.
 */
export const collapseToServices = (
  profiles: VectorIndexProfile[],
): MappingServiceViewModel[] => {
  const byId = new Map<string, MappingServiceViewModel>();
  for (const profile of profiles) {
    const vm = buildMappingServiceViewModel(profile);
    const existing = byId.get(vm.id);
    if (!existing || (vm.isDefault && !existing.isDefault)) {
      byId.set(vm.id, vm);
    }
  }
  return Array.from(byId.values()).sort((a, b) => a.id.localeCompare(b.id));
};
